export default class BackofficeResiliationRequestsBase {
  constructor(tableId, orderColumn) {
    this.tableId = tableId;
    this.orderColumn = orderColumn;
    this.initDataTable();
    this.bindEvents();
  }

  initDataTable() {
    if ($(`#${this.tableId}`).length > 0) {
      $(`#${this.tableId}`).DataTable({
        "responsive": true,
        "searching": true,
        "ordering": true,
        "paging": true,
        "info": true,
        "columnDefs": [
          {
            "targets": -1,
            "orderable": false
          }
        ],
        "order": [[this.orderColumn, "desc"]],
        "language": {
          url: '/assets/data-tables/locales/' + I18n.locale + '.json'
        },
        "lengthMenu": [
          [10, 25, 50, -1],
          [10, 25, 50, "All"]
        ]
      });
    }
  }

  bindEvents() {
    // Gestion des tooltips
    $('[data-toggle="tooltip"]').tooltip();
    
    // Gérer l'ouverture de la modale pour voir le motif
    $(document).on('click', '[data-toggle="modal"][data-target="#reasonModal"]', function(e) {
      const reason = $(this).data('reason');
      const service = $(this).data('service');
      
      $('#modal-service-number').text(service || 'N/A');
      
      if (reason && reason.trim()) {
        $('#modal-reason-text').html(reason.replaceAll('\n', '<br>'));
      } else {
        $('#modal-reason-text').html('<em class="text-muted">Aucun motif spécifié</em>');
      }
    });
  }

  onDataChanged(data) {
    // To be overridden
  }
}